import React, { JSX } from 'react'

interface BoxProps {
  className?: string
  as?: keyof JSX.IntrinsicElements
  children?: React.ReactNode
}

const Box: React.FC<BoxProps> = ({ as = 'div', className, children }) => {
  return React.createElement(
    as,
    {
      className: `
        bg-white rounded-[4px] pt-12 pb-14 px-4 md:px-8 max-w-5xl mx-auto space-y-7 Box ${className || ''}
      `
    },
    children
  )
}

export { Box }